<template>
  <v-card width="400" outlined>
    <v-card-title>New Box</v-card-title>
    <v-card-text>
      <!-- {{this.ac}} -->
      <v-form v-model="isValid">
        <v-text-field
          v-model="boxname"
          :counter="6"
          outlined=""
          prepend-inner-icon="mdi-text-box-outline"
          placeholder="Box Name"
          required
          :rules="[
            (v) => !!v || 'Box name is required',
            (v) => (v && v.length < 7) || 'Max length 6',
          ]"
        ></v-text-field>
        <v-text-field
          v-model="boxdescription"
          :counter="40"
          outlined=""
          prepend-inner-icon="mdi-text-box-plus-outline"
          placeholder="Description"
          required
          :rules="[
            (v) => !!v || 'Box description is required',
            (v) => (v && v.length < 41) || 'Max length 40',
          ]"
        ></v-text-field>
        <v-card justify="space-around">
          <v-card-title>Select a location for the box <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                large
                v-on="on"

              >
                <v-icon color="green">mdi-information</v-icon>
              </v-btn>
            </template>
            <span>Used to center mapapplications, like SafeSky etc.</span>
          </v-tooltip></v-card-title>
          
          <!-- <v-text-field
            v-model="locationName"
            :counter="40"
            outlined
            label="Location Name"
            prepend-inner-icon="mdi-text-box-plus-outline"
            placeholder="Location Name"
            required
            :rules="[
              (v) => !!v || 'Location name is required',
              (v) => (v && v.length < 41) || 'Max length 40',
            ]"
          ></v-text-field> -->
          <v-card-subtitle>Zoom and double click..</v-card-subtitle>
          <div v-if="posInitiated">
            <SelectMapPosition
              v-bind="postposition"
              @pos_changed="selectedPosition"
            ></SelectMapPosition>
          </div>
          <v-row>
            <v-col>
              <v-text-field
                v-model="lat"
                outlined
                type="Number"
                label="Latitude"
                prepend-inner-icon="mdi-map-marker-plus-outline"

                required
                disabled
              ></v-text-field>
              <!-- :rules="[
                  (v) => !!v || 'Latitude must be a desimal number',
                  (v) => (v && v.length < 21) || 'Max length 20',
                ]" -->
            </v-col>
            <v-col>
              <v-text-field
                v-model="lon"
                outlined
                type="Number"
                label="Longitude"
                prepend-inner-icon="mdi-map-marker-plus-outline"
                required
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>

        <Flags
          v-bind="post"
          @valueChangedMethodInComponent="setValueMethodInView"
          v-if="false"
        ></Flags>
        <!-- {{valueInComponent}} -->
        <!-- </div> -->
         <div>.</div>
        <v-row class="d-flex justify-space-around">
          <v-col> </v-col>
          <v-col>
            <v-btn :disabled="!isValid" color="primary" @click="submit" rounded
              >Submit</v-btn
            >
          </v-col>
          <v-col>
            <v-btn color="lightgrey" link :to="cancellink.to" rounded
              >Close</v-btn
            >
          </v-col>
        </v-row>
        <div>.</div>
        <v-alert type="success" :value="isAlertVisible">
          {{ statusResultMsg }}
        </v-alert>
        <v-alert type="warning" :value="isWarningAlertVisible">
          {{ statusResultMsg }}
        </v-alert>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from "axios";
import SelectMapPosition from "@/components/airbox/SelectMapPosition.vue";

export default {
  name: "RegForm",
  props: {
    box: [],
    regId: Number,
    ac: String,
  },
  data: () => ({
    boxname: null,
    boxdescription: null,
    isValid: true,
    isAlertVisible: false,
    isWarningAlertVisible: false,
    select: null,
    errors: [],
    statuses: [],
    statusResult: Number,
    statusResultMsg: String,
    cancellink: { to: "/boxadmin" },
    text: String,
    showComponent: Boolean,
    compValue: String,
    valueInComponent: String,

    lat: 59.5074,
    lon: 9.9072,

    postposition: {
      ilat: Number,
      ilng: Number,
      izoom: Number,
    },
    posSelected: Boolean,
    posInitiated: Boolean,
    selectedLat: Number,
    selectedLng: Number,
    showLocation: Boolean,
  }),

  created() {
    // this.baseUrl = 'http://localhost:3000/dbapi/' //https://pgbox.azurewebsites.net:3000/
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    this.boxname = null;
    this.boxdescription = null;
    this.statusResult = null;
    this.statusResultMsg = null;
    this.valueInComponent = "no";
    // this.setNationCode();
    this.selectedLat = null;
    this.selectedLng = null;
    this.posSelected = false;
    this.posInitiated = false;
    this.setInitPosition();
    this.showLocation = true;
  },
  methods: {
    submit() {
      var regId = this.regId;
      var ac = this.ac;
      var eventName = this.boxname;
      var eventDescription = this.boxdescription;
      var lat = this.lat;
      var lon = this.lon;
      //   var countrycode = this.valueInComponent
      var toSubmit = JSON.stringify({ regId, ac, eventName, eventDescription,lat,lon });
      const uri = this.baseUrl + "newbox";
      // console.log("uri:", uri);
      // console.log("toSubmit:", toSubmit);
      this.postRegistration(uri, toSubmit);
    },

    postRegistration(uri, toSubmit) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          // console.log("response", response.data);
          this.statusResult = response.data[0].Result;
          this.statusResultMsg = response.data[0].ResultMsg;
          this.setAlert(this.statusResult);
          // if(this.statusResultMsg == 1) {
          // something
          // }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    setNationCode() {
      this.post.id = 1;
      this.post.text = "no";
    },
    setValueMethodInView(value) {
      this.valueInComponent = value;
    },

    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
    },
    selectedPosition(pos) {
      // console.log("selectedPosition",pos);
      this.selectedLat = pos.lat;
      this.selectedLng = pos.lng;
      this.lat = pos.lat;
      this.lon = pos.lng;
      this.posSelected = true;
    },
    setInitPosition() {
      this.postposition.ilat = 59.5074;
      this.postposition.ilng = 9.9072;
      this.postposition.izoom = 8;
      //   console.log("postposition", this.postposition);
      this.posInitiated = true;
    },
  },
  components: {
    Flags: () => import("@/components/Admin/Flags.vue"), //Denne rendrer ved behov <div v-if..>
    SelectMapPosition,
  },
};
</script>